/**
 * Fallback prod si REACT_APP_API_URL vacío.
 * En local usa :3002 para el back — Cursor suele ocupar localhost:3001 y tunelar a prod.
 */
const getFallbackApiUrl = () => "https://crm.stagedesign.app:3001";

export const API_URL = (
  process.env.REACT_APP_API_URL ||
  getFallbackApiUrl()
).trim();

